module.exports = __webpack_public_path__ + "static/img/id-card-front.8466f77f.png";